import $ from "jquery";
import 'tw-elements';
import counterUp from 'counterup2';
import 'jquery-mask-plugin';



//import smoothscroll from "smoothscroll-polyfill";
import '../node_modules/lite-youtube-embed/src/lite-yt-embed.js';


import "./components/counter-up.js";
import "./components/toggle-copy.js";

// Base level imports 

// IMPORT CONSTANT variables
//import './components/config.js';

// import "./components/tabs.js";
// import "./components/modal.js";

import "./components/utilities.js"; 
//import "./components/cookie.js"; // for Notice message option

// ****************************************
// Modified from base level 'imports'

import "./components/contact-form-submit-with-ajax.js";
import "./components/tiny-sliders.js";
import "./components/fancyapps-carousels-with-lightbox.js";
//import "./components/video-autoplay-low-power-mode.js";
//import "./components/scroll-animations.js";

import "./components/forms.js";
// import "./components/break-section-content-into-columns.js";


import "./styles/main.scss";


var assignCurrency = (function () {

  var onSuccess = function (geoipResponse) {
      var code = geoipResponse.country.iso_code;
      if (code !== 'US') {
        var currency = 'cad';
      } else {
        var currency = 'usd';
      }
      //Snipcart.api.session.setCurrency(currency);
      //Snipcart.options.currency = currency;
      console.log('Country Code: ', geoipResponse);
      $('body').addClass('curr-' + currency);

  };

  var onError = function (error) {
      console.log('Error: ', error);
      return 'err';
  };

  return function () {
      geoip2.country( onSuccess, onError );
  };

}());


function when(selector, callback, interval = 50) {
	const elements = document.querySelectorAll(selector);
	if (elements.length) return callback(elements);

	if (document.readyState === 'complete') return;

	const next = when.bind(null, selector, callback, interval);
	return setTimeout(next, interval);
}

// function pollForSnipcart(callback) {

// 	if (!window.Snipcart) {
// 		return setTimeout(pollForSnipcart.bind(null, callback), 50);
// 	}

// 	const snipcart = window.Snipcart;
// 	callback(snipcart);
// }


function pollForGeoIp(callback) {
	if (!window.geoip2) {
		return setTimeout(pollForGeoIp.bind(null, callback), 50);
	}
	const geoip = window.geoip2;
	callback(geoip);
}

$(document).ready(function() {
    
   // getCountry();


	$('.card-expires').mask("00/0000", {placeholder: "MM/YYYY"});
	$('.card-code').mask("0000", {placeholder: "123"});

    pollForGeoIp((geoip2) => {
      assignCurrency();
      //console.log('geoip2:', geoip2);
      // pollForSnipcart((snipcart) => {
        
        
      // })
    });

    $('#close-menu').on('click mousedown', function() {
      //alert('Close Menu');
      $('#site-navigation').removeClass('open');
    });
    
    $('#open-menu').on('click mousedown', function() {
      //alert('Open Menu');
      $('#site-navigation').addClass('open');
    });

    $('.product-size').on('change', function(e) {
      //console.log('Value:', $(this).val());
      var link = $(this).val();
      var entry_id = $(this).closest('[data-product-id]').attr('data-product-id');
      $('.cad-cart-button[data-product-id="' + entry_id + '"]').attr('href', link);
      //console.log('product id:', entry_id);
    });

});



